import type { TranslationKey } from '@/types/translation-keys'

type TranslationsMap = Record<string, Record<TranslationKey, string> & Record<string, string>>

export const translations: TranslationsMap = {
  es: {
    // Navigation
    home: 'Inicio',
    map: 'Mapa',
    audit: 'Verificar terreno',
    profile: 'Perfil',
    login: 'Iniciar sesión',
    loginWelcome: 'Bienvenido a {appName}',
    loginSubtitle: 'Accedé a datos satelitales y reportes especializados\\npara proteger nuestros bosques.',
    loginGoogle: 'Continuar con Google',
    loginEmail: 'Continuar con email',
    loginGuestDivider: 'o continuá como invitado',
    loginGuestAction: 'Acceder como invitado',
    logout: 'Cerrar Sesión',
    register: 'Registrarse',
    registerTitle: 'Registrate para poder acceder a todas las funcionalidades',
    registerSubtitle: '',
    registerAction: 'Registrarme con email',
    registerSuccess: 'Te enviamos un link para finalizar el registro.',
    registerError: 'No se pudo iniciar el registro',
    registerGuestDivider: 'o continuá como invitado',
    registerGuestAction: 'Acceder como invitado',
    registerHaveAccount: '¿Ya tenés cuenta?',
    firstName: 'Nombre',
    lastName: 'Apellido',
    certificates: 'Certificados',
    shelters: 'Refugios',
    report: 'Reportar',
    reports: 'Explorá',
    seeDetail: 'Ver detalle',
    creditsTitle: 'Créditos',
    creditsDescription: 'Compra créditos para reportes judiciales o históricos.',
    creditsBalance: 'Saldo de créditos',
    creditsBalanceHint: 'Los créditos se acreditan automáticamente después del pago.',
    creditsPackages: 'Paquetes disponibles',
    creditsPackagesHint: 'Seleccioná un paquete para continuar con el pago.',
    creditsPackageLabel: 'Créditos',
    creditsBuy: 'Comprar',
    creditsPurchaseTitle: 'Comprar creditos',
    creditsPurchaseDescription: 'Indica la cantidad de creditos y continua con MercadoPago.',
    creditsAmountLabel: 'Cantidad de creditos',
    creditsAmountPlaceholder: 'Ej: 10',
    creditsAmountHint: 'Min 1, max 100',
    creditsAmountError: 'Ingresá una cantidad entre 1 y 100.',
    creditsProceed: 'Ir a MercadoPago',
    editProfile: 'Editar perfil',
    profileTitle: 'Perfil de usuario',
    profileDescription: 'Actualizá tus datos y gestioná tus créditos.',
    profileEditTitle: 'Datos personales',
    profileEditDescription: 'Actualizá la información básica de tu cuenta.',
    profileNameLabel: 'Nombre completo',
    profileNamePlaceholder: 'Tu nombre',
    profileEmailLabel: 'Email',
    profileSave: 'Guardar cambios',
    profileSaveSuccess: 'Perfil actualizado',
    profileSaveError: 'No se pudo actualizar el perfil',
    profileCreditsTitle: 'Agregar créditos',
    profileCreditsDescription: 'Comprá créditos para acceder a reportes premium.',
    navExplore: 'Explorar',
    navTools: 'Herramientas',
    navAccount: 'Cuenta',
    navHelp: 'Ayuda',
    navMoreInformation: 'Más información',
    navMenu: 'Menu',
    navOpenMenu: 'Abrir menu de navegacion',
    navPreferences: 'Preferencias',

    // Common
    viewDetails: 'Ver detalles',
    goBack: 'Volver atrás',
    download: 'Descargar',
    submit: 'Enviar',
    cancel: 'Cancelar',
    next: 'Siguiente',
    previous: 'Anterior',
    search: 'Buscar',
    filter: 'Filtrar',
    all: 'Todos',
    active: 'Activo',
    monitoring: 'Monitoreo',
    extinguished: 'Extinguido',
    loading: 'Cargando...',
    authRequired: 'Inicia sesion para continuar.',
    protectedPageTitle: 'Acceso restringido',
    protectedPageMessage: 'Esta página es exclusiva para usuarios registrados. Por favor, iniciá sesión para continuar.',

    // Fire Feed
    fireFeed: 'Incendios forestales',
    activeFiresArgentina: 'Incendios activos en Argentina',
    fireHistory: 'Históricos',
    highSeverity: 'Alta Severidad',
    mediumSeverity: 'Media Severidad',
    lowSeverity: 'Baja Severidad',
    hectares: 'hectáreas',
    province: 'Provincia',
    status: 'Estado',
    severity: 'Severidad',
    date: 'Fecha',
    recentFiresToggle: 'Mostrar recientes',
    recentFiresEmpty: 'No hay incendios activos ni recientes en los últimos 60 días.',
    fireLoadError: 'Error al cargar incendios',
    fireLoadErrorDetail: 'No pudimos obtener los datos. Verificá tu conexión e intentá de nuevo.',
    sortByDate: 'Ordenar por fecha',
    sortNewestFirst: 'Más recientes primero',
    sortOldestFirst: 'Más antiguos primero',

    // Fire Detail
    reliabilityScore: 'Puntuación de Confiabilidad',
    landUseStatus: 'Estado de Uso del Suelo',
    vegetationRecovery: 'Recuperación de Vegetación (NDVI)',
    downloadReport: 'Descargar Informe Técnico',
    reportSuspicious: 'Reportar Actividad Sospechosa',
    prohibitedLandUse: 'Uso del Suelo Prohibido',
    protectedArea: 'Área Protegida',
    underReview: 'En Revisión',
    noRestrictions: 'Sin Restricciones',
    qualityIndicator: 'Calidad de datos',
    qualityClassification: 'Clasificación',
    qualityHigh: 'Alta',
    qualityMedium: 'Media',
    qualityLow: 'Baja',
    avgConfidence: 'Confianza promedio',
    detections: 'Detecciones',
    independentSources: 'Fuentes independientes',
    imagery: 'Imágenes',
    imageryUnavailable: 'Sin im?genes satelitales disponibles',
    climate: 'Clima',
    ndvi: 'NDVI',
    qualityUnavailable: 'Calidad de datos no disponible',
    qualityWarnings: 'Advertencias',
    qualityNoWarnings: 'Sin advertencias relevantes',
    qualityUpdatedAt: 'Actualizado',

    // Map
    interactiveMap: 'Incendios activos',
    clickForDetails: 'Haga clic para más detalles',
    area: 'Área',
    firePopupTitleActive: 'Incendio activo',
    firePopupTitleMonitoring: 'Incendio en monitoreo',
    firePopupTitleControlled: 'Incendio controlado',
    firePopupTitleExtinguished: 'Incendio extinguido',
    severityHigh: 'Severidad alta',
    severityMedium: 'Severidad media',
    severityLow: 'Severidad baja',
    protectedAreaLabel: 'Área protegida',
    popupHectaresAmount: 'Cantidad ha',
    popupProtectedAreaPercentage: 'Porcentaje área protegida afectado',
    popupProtectedAreas: 'Áreas protegidas',
    mapLegendActive: 'Activos',
    mapLegendRecent: 'Recientes (60 días)',

    // Audit / Verificar terreno
    landUseAudit: 'Verificar terreno',
    auditDescription: 'Investigá si una zona se incendió, cómo cambió la vegetación y qué señales quedan en el paisaje.',
    auditLocationInput: 'Buscar lugar',
    auditLocationHint: 'Buscá por dirección o marcá un punto en el mapa.',
    auditMapHint: 'Marcá un punto en el mapa para continuar.',
    latitude: 'Latitud',
    longitude: 'Longitud',
    radiusMeters: 'Radio (metros)',
    pickOnMap: 'Seleccionar en Mapa',
    runAudit: 'Verificá',
    auditResult: 'Resultados de la verificación',
    explorationInstruction:
      'Elegí un área que haya sufrido un incendio. Conseguí una imagen satelital de antes para tener un punto de partida. Después, buscá un máximo de 12 imágenes satelitales en HD, con periodicidad mensual o anual, para ver cómo evolucionó el terreno afectado. Analizá si la vegetación se recuperó o si hubo otros cambios importantes en la zona.',
    constructionProhibited: 'Construcción Prohibida',
    prohibitedUntil: 'Prohibido hasta',
    noRestrictionsFound: 'No se encontraron restricciones',
    reportsTitle: 'Explorá la evolución del terreno',
    reportsDescription:
      'Elegí un incendio y compará el antes y después en imágenes HD. Investigá por tu cuenta qué cambió y cuándo.',
    explorationDisclaimer:
      'Esto no es una acusación: es una herramienta para observar cambios con evidencia satelital.',
    explorationHowTitle: 'Cómo funciona',
    explorationHowStep1: 'Elegís un incendio (provincia, fecha o mapa).',
    explorationHowStep2: 'Seleccionás hasta 12 fechas para generar imágenes.',
    explorationHowStep3: 'Generás imágenes HD y las comparás.',
    explorationDemoTitle: 'Antes y después (ejemplo)',
    explorationDemoHint: 'Ilustración orientativa, sin generar imágenes.',
    explorationDemoExample: 'Ejemplo ilustrativo.',
    explorationStep1Title: 'Elegí un incendio',
    explorationStep1Subtitle: 'Buscá por provincia, fecha o texto libre.',
    explorationStep2Title: 'Elegí período y cantidad',
    explorationStep2Subtitle: 'Definí antes y después. Máximo 12 imágenes.',
    explorationStep3Title: 'Tu investigación',
    explorationStep3Subtitle: 'Revisá fechas, costo total y guardá el borrador.',
    explorationAdvancedIdLabel: 'Tengo el ID del evento',
    explorationAdvancedIdPlaceholder: 'UUID del incendio',
    explorationAdvancedIdAction: 'Cargar evento',
    explorationCoordsTitle: 'Búsqueda por coordenadas',
    explorationCoordsHint: 'Ingresá latitud, longitud y radio para buscar incendios cercanos.',
    explorationCoordsError: 'Completá latitud, longitud y radio válidos.',
    explorationMapSelect: 'Elegir en el mapa',
    explorationSearchPlaceholder: 'Ej: Corrientes 2022, El Bolsón 2021',
    explorationResults: 'Resultados',
    explorationSelect: 'Seleccionar',
    explorationSelected: 'Seleccionado',
    explorationBeforeLabel: 'Antes del incendio',
    explorationAfterLabel: 'Después del incendio',
    explorationTotalLabel: 'Cantidad total',
    explorationPresetsLabel: 'Recomendaciones rápidas',
    explorationMoreDetail: 'Más imágenes = más detalle temporal.',
    explorationTimelineTitle: 'Timeline sugerida',
    explorationTitleLabel: 'Título de tu investigación (opcional)',
    explorationTitlePlaceholder: '¿Qué pasó en esta zona?',
    explorationAddItemLabel: 'Agregar fecha',
    explorationAddItemAction: 'Agregar',
    explorationCostLabel: 'Resumen de costo',
    explorationConfirmTitle: 'Confirmar generación',
    explorationConfirmDescription: 'Se descontarán de tu cuenta',
    explorationConfirmAction: 'Confirmar y generar',
    explorationDownloadTitle: 'Elegí formato de descarga',
    explorationAuthTitle: 'Acceso requerido para generar el informe',
    explorationAuthMessageLine1: 'Para generar este reporte personalizado necesitás una cuenta.',
    explorationAuthMessageLine2:
      'El registro es gratuito y te permite acceder a tus informes, historial y descargas.',
    explorationAuthBack: 'Volver atrás',
    explorationAuthLogin: 'Registrarme / Iniciar sesión',
    explorationGenerationStarted: 'Generación iniciada. ID:',
    explorationTrackingTitle: 'Generación en progreso',
    explorationTrackingIdLabel: 'ID de seguimiento:',
    explorationInsufficientCredits: 'Créditos insuficientes',
    explorationSave: 'Guardar hallazgos',
    explorationGenerate: 'Generar imágenes HD',
    explorationCostNote:
      'Cada imagen HD se genera a pedido y tiene costo por consulta satelital. Solo se cobra lo que elijas generar.',
    explorationNoResultsTitle: 'No encontramos incendios con esos filtros.',
    explorationNoResultsHint: 'Probá: Corrientes 2022 · El Bolsón 2021.',
    explorationAddressNotInProvince: 'La dirección no existe en la provincia seleccionada.',
    explorationDatesRequired: 'Faltan definir las fechas (desde y hasta) para buscar.',
    explorationEventSummary: 'Resumen del evento',
    explorationMapPreview: 'Mapa del incendio',
    explorationDetectTitle: 'Qué podrías detectar',
    explorationDetectOption1: 'Nuevas construcciones',
    explorationDetectOption2: 'Apertura de caminos',
    explorationDetectOption3: 'Movimiento de suelo',
    explorationDetectOption4: 'Cambios en cobertura vegetal',
    explorationDetectOption5: 'Cambios de parcelado o límites visibles',
    explorationHypothesisTitle: 'Elegí una hipótesis',
    explorationHypothesis1: '¿Se construyó después del incendio?',
    explorationHypothesis2: '¿Cambió el uso del suelo?',
    explorationHypothesis3: '¿Se recuperó la vegetación?',
    explorationEstimateTag: 'Estimado',
    explorationUpdateCost: 'Actualizar costo',
    explorationLoadingQuote: 'Calculando costo...',
    explorationLoadMore: 'Cargar más',
    explorationSaved: 'Investigación guardada',
    explorationGenerateSoon: 'Pronto podrás generar imágenes HD.',
    explorationMapLoading: 'Cargando mapa...',
    reportType: 'Tipo de reporte',
    judicialReport: 'Judicial',
    judicialReportHint: 'Peritaje legal con cadena de custodia.',
    historicalReport: 'Histórico',
    historicalReportHint: 'Evolución temporal en áreas protegidas.',
    reportFireEventId: 'ID del incendio',
    reportRequesterName: 'Nombre del solicitante',
    reportCaseReference: 'Referencia del caso',
    reportIncludeImagery: 'Incluir imágenes satelitales',
    reportIncludeImageryHint: 'Imágenes HD para sustento legal.',
    reportIncludeClimate: 'Incluir datos climáticos',
    reportIncludeClimateHint: 'Contexto meteorológico del evento.',
    reportProtectedAreaId: 'ID de área protegida',
    reportProtectedAreaName: 'Nombre del área protegida',
    reportStartDate: 'Fecha de inicio',
    reportEndDate: 'Fecha de fin',
    reportMaxImages: 'Máximo de imágenes',
    reportIncludeMonthly: 'Incluir imágenes mensuales',
    reportIncludeMonthlyHint: 'Serie mensual post-incendio.',
    reportEstimatedCost: 'Créditos estimados',
    reportSubmit: 'Solicitar reporte',
    reportCreditsAvailable: 'Créditos disponibles',
    reportCreditsRequired: 'Créditos requeridos',
    reportCreditsHint: '1 crédito = 1 imagen HD (máx. 12)',
    creditsFallback: 'Saldo estimado (modo demo).',
    reportPendingApproval: 'Solicitud pendiente de aprobación',
    reportPendingApprovalMessage:
      'El saldo es insuficiente. La solicitud quedará en revisión por un administrador.',
    reportSubmitted: 'Reporte generado',
    reportReady: 'Reporte listo',
    reportReadyMessage: 'El reporte fue generado y está disponible para descarga.',
    reportDownload: 'Descargar reporte',
    reportOpenViewer: 'Abrir visor',
    reportVerificationHash: 'Hash de verificación',
    reportId: 'ID de reporte',
    reportGeneratedAt: 'Generado',
    reportFiresIncluded: 'Incendios incluidos',
    reportError: 'Error en la solicitud',
    reportDateRangeInvalid: 'La fecha de fin debe ser posterior a la de inicio',
    reportProtectedAreaRequired: 'Ingrese ID o nombre del área protegida',
    reportMaxImagesRange: 'Debe estar entre 1 y 12',
    invalidValue: 'Valor inválido',
    firesFound: 'Incendios encontrados',
    distanceMeters: 'Distancia (m)',
    yearsRemaining: 'Años restantes',
    auditWarnings: 'Advertencias',
    verifyTerrain: 'Verificar terreno',
    verifySubtitle: 'Investigá si una zona se incendió, cómo cambió la vegetación y qué señales quedan en el paisaje.',
    verifyMicrocopyA: 'Algunos incendios son accidentales; otros pueden tener intereses detrás. Acá podés mirar evidencia y sacar tus conclusiones.',
    verifyMicrocopyB: 'Esto no demuestra intencionalidad por sí solo. Sirve para contrastar relatos con evidencia observable.',
    searchPlace: 'Buscar lugar',
    searchPlaceholder: 'Dirección, localidad, parque nacional o provincia',
    searchTypeLabel: 'Tipo de búsqueda',
    searchTypeAddress: 'Dirección',
    searchTypeLocality: 'Localidad',
    searchTypePark: 'Parque',
    searchTypeProvince: 'Provincia',
    searchTypeMinLength: 'Mínimo {min} caracteres',
    searchTypeInvalidFormat: 'Formato inválido',
    analysisArea: 'Área de análisis',
    advancedOptions: 'Opciones avanzadas',
    customRadius: 'Personalizar radio (m)',
    verifyCTA: 'Verificá',
    whatYouWillSee: 'Lo que vas a ver',
    seeTimeline: 'Línea de tiempo de incendios detectados',
    seeVegetation: 'Evolución de la vegetación (indicadores)',
    seeGallery: 'Galería de evidencia (thumbnails)',
    seeSignals: 'Señales a favor/en contra de recuperación',
    emptyHint: 'Marcá un punto en el mapa y presioná Verificá.',
    loadingFires: 'Buscando incendios históricos…',
    loadingVegetation: 'Calculando evolución de vegetación…',
    loadingEvidence: 'Cargando evidencia visual…',
    errorTitle: 'No se pudo verificar',
    noPointError: 'Primero marcá un punto en el mapa.',
    technicalError: 'Hubo un problema técnico. Intentalo de nuevo.',
    geocodeLoading: 'Buscando ubicación…',
    geocodeNotFound: 'No pudimos ubicar ese lugar. Probá con otra búsqueda o marcá un punto en el mapa.',
    auditSearchLoading: 'Buscando episodios históricos…',
    resolvedPlace: 'Lugar resuelto',
    episodesFound: 'Episodios encontrados',
    dateRange: 'Rango',
    auditSearchEmpty: 'No se encontraron episodios para ese lugar.',
    placeTypeProvince: 'Provincia',
    placeTypeProtectedArea: 'Área protegida',
    placeTypeAddress: 'Dirección',
    retry: 'Reintentar',
    verificationChecklist: 'Checklist de verificación',
    checklist1: '¿Hubo incendios en los últimos años en esta zona?',
    checklist2: '¿La vegetación se recuperó o quedó degradada?',
    checklist3: '¿Persisten señales del incendio en el área?',
    checklist4: '¿Qué dicen fuentes públicas y registros locales?',
    evidenceGallery: 'Galería de evidencia',
    loginToDownload: 'Iniciar sesión para descargar',
    hideMap: 'Ocultar mapa',
    results: 'Resultados',
    requiredField: 'Campo obligatorio',
    eventsLabel: 'Eventos',
    invalidNumber: 'Número inválido',
    outOfRange: 'Valor fuera de rango',

    // Certificates
    certificateCenter: 'Centro de Certificados',
    requestCertificate: 'Solicitar Certificado',
    verifyCertificate: 'Verificar Certificado',
    cadastralId: 'ID Catastral',
    ownerName: 'Nombre del Propietario',
    issueCertificate: 'Emitir Certificado',
    certificateId: 'ID de Certificado',
    verify: 'Verificar',
    valid: 'Válido',
    invalid: 'Inválido',
    certificateIssued: 'Certificado Emitido',
    certificateValid: 'El certificado es válido',
    certificateInvalid: 'El certificado no es válido o no existe',

    // Citizen Report
    citizenReport: 'Reporte Ciudadano',
    reportWizard: 'Asistente de Reporte',
    selectLocation: 'Seleccionar Ubicación',
    uploadPhoto: 'Subir Foto',
    description: 'Descripción',
    submitReport: 'Enviar Reporte',
    reportSuccess: 'Paquete de Evidencia Generado',
    reportSuccessMessage: 'Su reporte ha sido enviado exitosamente y será revisado por las autoridades.',
    descriptionPlaceholder: 'Describa la actividad sospechosa que observó...',

    // Shelters
    visitorLog: 'Registro de Visitantes',
    shelterName: 'Nombre del Refugio',
    hikerName: 'Nombre del Excursionista',
    groupSize: 'Tamaño del Grupo',
    checkIn: 'Registrar Entrada',
    syncStatus: 'Estado de Sincronización',
    online: 'En Línea',
    offline: 'Sin Conexión (Guardado Localmente)',
    checkInSuccess: 'Registro exitoso',

    // Login
    email: 'Correo electrónico',
    password: 'Contraseña',
    loginButton: 'Iniciar Sesión',
    noAccount: '¿No tienes cuenta?',
    loginError: 'Por favor complete todos los campos',
    loginInvalid: 'Credenciales invalidas',
    loginSuccess: 'Inicio de sesión exitoso',


    // Footer
    legal: 'Legal',
    contact: 'Contacto',
    apiDocs: 'Documentación API',

    // Roles
    guest: 'Invitado',
    user: 'Usuario',
    admin: 'Administrador',

    // PaymentReturnPage
    paymentLoadingSession: 'Cargando sesión...',
    paymentRestoringSession: 'Estamos restaurando tu sesión antes de verificar el pago.',
    paymentSessionRequired: 'Sesión requerida',
    paymentLoginToVerify: 'Inicia sesión para verificar el estado del pago.',
    paymentGoToLogin: 'Ir a login',
    paymentNotFound: 'Pago no encontrado',
    paymentIdentifyError: 'No pudimos identificar el pago. Volve a intentar desde Créditos.',
    paymentGoToCredits: 'Ir a Créditos',
    paymentVerificationInProgress: 'Verificación en proceso',
    paymentProcessingMessage: 'Tu pago está siendo procesado. Recibirás un email de confirmación cuando se acredite.',
    paymentGoToHome: 'Volver al inicio',
    paymentVerifying: 'Verificando pago...',
    paymentPleaseWait: 'Por favor espera mientras confirmamos tu pago.',
    paymentSuccessful: '¡Pago exitoso!',
    paymentCreditedMessage: 'Tus créditos han sido acreditados a tu cuenta.',
    paymentContinue: 'Continuar',
    paymentRejected: 'Pago rechazado',
    paymentRejectedMessage: 'No pudimos procesar tu pago. Por favor intenta nuevamente.',
    paymentTryAgain: 'Intentar de nuevo',

    // Register Validation
    validationRequired: 'Campo requerido',
    validationMax50: 'Max 50 caracteres',
    validationInvalidEmail: 'Email inválido',

    // Login Hero
    loginHeroTitle: 'La huella del fuego, vista desde el espacio.',
    loginHeroSubtitle: 'Explorá el impacto del fuego y monitoreá la recuperación del terreno.',
    loginHeroDescription: '',
    loginIdleSession: 'Sesión cerrada por inactividad',

    // NotFound
    notFoundTitle: 'Página no encontrada',
    notFoundMessage: 'La página que buscas no existe o fue movida.',
    notFoundBackHome: 'Volver al inicio',

    // FireCard
    statusActive: 'Activo',
    statusMonitoring: 'Monitoreo',
    statusExtinct: 'Extinto',
    statusClosed: 'Cerrado',
    noProvince: 'Sin provincia',
    goToSlide: 'Ir a la diapositiva {index}',
    imagePending: 'Imagen pendiente',
    recentLabel: 'Reciente',

    // Language Selector
    languageSpanish: 'Español',
    languageEnglish: 'English',
    toggleLanguage: 'Cambiar idioma',

    // Manual
    manualTitle: 'Manual de Usuario',
    manualSubtitle: 'Guía completa para utilizar {appName}',
    manualContent: 'Contenido',
    manualNavigation: 'Navegación',
    manualPrevious: 'Anterior',
    manualNext: 'Siguiente',
    manualSectionCounter: 'Sección {current} de {total}',
    manualSectionGettingStarted: 'Primeros Pasos',
    manualSectionFireMap: 'Mapa de Incendios',
    manualSectionLegalAudit: 'Verificación de terreno',
    manualSectionReports: 'Reportes Ciudadanos',
    manualSectionCertificates: 'Certificados',
    manualGettingStartedP1: 'Bienvenido a {appName}, la plataforma de monitoreo y recuperación de incendios forestales de Argentina.',
    manualGettingStartedP2: 'Esta guía te ayudará a aprovechar todas las funcionalidades disponibles.',
    manualRegisterAccessTitle: 'Registro y Acceso',
    manualRegisterAccess1: 'Accede a la página de inicio de {appName}',
    manualRegisterAccess2: 'Haz clic en "Iniciar Sesión" en la barra de navegación',
    manualRegisterAccess3: 'Ingresa tu correo electrónico y contraseña',
    manualRegisterAccess4: 'Para cuentas de administrador, usa un email con dominio @{appSlug}.ar',
    manualMainNavTitle: 'Navegación Principal',
    manualMainNav1: 'Inicio: Feed de incendios activos con filtros',
    manualMainNav2: 'Mapa: Visualización geográfica interactiva',
    manualMainNav3: 'Verificar terreno: Explorá el historial de incendios y la evolución del suelo',
    manualMainNav4: 'Certificados: Emisión y verificación de documentos',
    manualMapP1: 'El mapa interactivo muestra todos los incendios detectados en Argentina en tiempo casi real.',
    manualColorsTitle: 'Interpretación de Colores',
    manualColorLow: 'Verde: Baja severidad (FRP menor a 100 MW)',
    manualColorMedium: 'Amarillo: Media severidad (FRP 100-500 MW)',
    manualColorHigh: 'Naranja: Alta severidad (FRP 500-1000 MW)',
    manualColorCritical: 'Rojo: Crítico (FRP mayor a 1000 MW)',
    manualFeaturesTitle: 'Funcionalidades',
    manualFeatures1: 'Haz clic en un marcador para ver detalles del incendio',
    manualFeatures2: 'Usa los filtros laterales para filtrar por provincia o severidad',
    manualFeatures3: 'El zoom te permite explorar áreas específicas',
    manualAuditP1: 'La herramienta de verificación de terreno permite explorar si una zona fue afectada por incendios, cómo cambió la vegetación y qué señales quedan en el paisaje. Cruza información de la Ley 26.815 con datos satelitales para ofrecer contexto.',
    manualAuditHowToTitle: 'Cómo verificar un terreno',
    manualAuditHowTo1: 'Ingresa las coordenadas (latitud y longitud) de la parcela',
    manualAuditHowTo2: 'Alternativamente, usa el botón "Seleccionar en Mapa"',
    manualAuditHowTo3: 'Haz clic en "Verificá"',
    manualAuditHowTo4: 'El sistema buscará incendios históricos, mostrará la evolución de la vegetación y presentará evidencia visual',
    manualAuditResultsTitle: 'Resultados posibles',
    manualAuditResults1: 'Sin restricciones: No hay incendios recientes que afecten la parcela',
    manualAuditResults2: 'Construcción prohibida: La parcela está dentro de una zona afectada y tiene restricciones temporales',
    manualReportsP1: 'El sistema de reportes permite a cualquier ciudadano informar sobre actividad sospechosa relacionada con incendios forestales.',
    manualReportsStepsTitle: 'Pasos para crear un reporte',
    manualReportsSteps1: 'Ubicación: Selecciona el punto exacto en el mapa donde observaste la actividad',
    manualReportsSteps2: 'Fotografía: Sube una imagen como evidencia (opcional pero recomendado)',
    manualReportsSteps3: 'Descripción: Detalla lo que observaste con la mayor precisión posible',
    manualReportsSteps4: 'Envío: Confirma y envía el reporte para revisión',
    manualReportsTipsTitle: 'Recomendaciones',
    manualReportsTips1: 'Incluye fecha y hora aproximada de la observación',
    manualReportsTips2: 'Describe cualquier vehículo o persona involucrada',
    manualReportsTips3: 'No te pongas en riesgo para obtener evidencia',
    manualCertP1: 'El Centro de Certificados permite solicitar y verificar documentos oficiales sobre el estado de uso del suelo de una parcela.',
    manualCertRequestTitle: 'Solicitar un Certificado',
    manualCertRequest1: 'Accede al Centro de Certificados (requiere autenticación)',
    manualCertRequest2: 'Ingresa el ID Catastral de la parcela',
    manualCertRequest3: 'Completa el nombre del propietario',
    manualCertRequest4: 'El sistema generará un certificado con un código único',
    manualCertVerifyTitle: 'Verificar un Certificado',
    manualCertVerify1: 'Ingresa el código del certificado en la pestaña "Verificar"',
    manualCertVerify2: 'El sistema confirmará si es válido y mostrará los detalles',

    // Manual - Episodes
    manualSectionEpisodes: 'Episodios',
    manualEpisodesP1: 'Un episodio agrupa múltiples detecciones satelitales que corresponden al mismo incendio. Cuando un satélite pasa varias veces sobre la misma zona en llamas, cada pasada genera una detección independiente. {appName} las agrupa automáticamente en un único episodio para facilitar el seguimiento.',
    manualEpisodesP2: 'Los episodios permiten ver la evolución completa de un incendio: cuándo comenzó, cuánto duró, qué área cubrió y cómo evolucionó la vegetación después.',
    manualEpisodesHowTitle: 'Cómo se crean los episodios',
    manualEpisodesHow1: 'Las detecciones cercanas en espacio y tiempo se agrupan automáticamente mediante un algoritmo de clustering',
    manualEpisodesHow2: 'Se calcula un área estimada, duración y estadísticas de intensidad (FRP máximo, detecciones totales)',
    manualEpisodesHow3: 'Se asignan imágenes satelitales cuando están disponibles para la zona y las fechas del episodio',

    // FAQ
    faqTitle: 'Preguntas Frecuentes',
    faqSubtitle: 'Respuestas a las consultas más comunes sobre incendios forestales y nuestra plataforma',
    faqHint: 'Haz clic en cada pregunta para ver la respuesta',
    faqQ1: '¿Cómo detecta {appName} los incendios forestales?',
    faqA1: '{appName} utiliza datos satelitales de múltiples fuentes, incluyendo MODIS (NASA) y VIIRS, que detectan puntos de calor en tiempo casi real. Estos satélites orbitan la Tierra varias veces al día, capturando imágenes térmicas que permiten identificar focos de incendio activos. La información se procesa automáticamente y se muestra en nuestra plataforma con actualizaciones cada 6-12 horas.',
    faqQ2: '¿Qué significa el índice FRP (Fire Radiative Power)?',
    faqA2: 'El FRP o Potencia Radiativa del Fuego es una medida de la intensidad de un incendio, expresada en megawatts (MW). Indica la cantidad de energía que libera el fuego por unidad de tiempo. Un FRP más alto significa un incendio más intenso. En {appName}, clasificamos los incendios como: Baja severidad (<100 MW), Media severidad (100-500 MW), Alta severidad (>500 MW) y Crítico (>1000 MW).',
    faqQ3: '¿Qué es el NDVI y por qué es importante para la recuperación?',
    faqA3: 'El NDVI (Índice de Vegetación de Diferencia Normalizada) es un indicador que mide la salud y densidad de la vegetación utilizando imágenes satelitales. Sus valores van de -1 a 1, donde valores cercanos a 1 indican vegetación densa y saludable. Después de un incendio, monitoreamos el NDVI para evaluar la recuperación del ecosistema. Un aumento gradual del NDVI indica que la vegetación está regenerándose.',
    faqQ4: '¿Cómo funciona la Ley 26.815 de Manejo del Fuego?',
    faqA4: 'La Ley 26.815 establece presupuestos mínimos de protección ambiental en materia de incendios forestales. Un aspecto clave es que prohíbe el cambio de uso del suelo en áreas afectadas por incendios durante un período determinado (generalmente 60 años), para evitar que los incendios sean usados como herramienta para habilitar tierras para agricultura o construcción. La herramienta de verificación de terreno permite consultar si una zona está afectada por estas restricciones.',
    faqQ5: '¿Puedo reportar un incendio que detecté personalmente?',
    faqA5: 'Sí, {appName} cuenta con un sistema de Reporte Ciudadano que permite a cualquier persona reportar actividad sospechosa o incendios detectados visualmente. El sistema incluye geolocalización, carga de fotografías y descripción del evento. Todos los reportes son revisados por autoridades competentes y pueden servir como evidencia para investigaciones sobre incendios intencionales.',
    faqQ6: '¿De dónde provienen los datos de {appName}?',
    faqA6: '{appName} centraliza datos públicos de múltiples fuentes: detecciones de focos de calor de NASA FIRMS (satélites VIIRS y MODIS), imágenes multiespectrales de Sentinel-2 procesadas vía Google Earth Engine, datos climáticos de Open-Meteo (ERA5-Land), y geometrías de áreas protegidas de IGN y APN. Toda la información proviene de fuentes públicas y abiertas.',
    faqQ7: '¿Cómo se generan las imágenes satelitales?',
    faqA7: 'Las imágenes se generan a pedido a través de Google Earth Engine. {appName} envía una solicitud con las coordenadas y fechas seleccionadas, GEE procesa la imagen Sentinel-2 correspondiente y la entrega en formato optimizado. El proceso puede demorar entre 30 segundos y varios minutos según la carga del servicio.',
    faqQ8: '¿{appName} prueba responsabilidad legal sobre los incendios?',
    faqA8: 'No. {appName} es una herramienta de exploración de datos públicos. Los datos se presentan tal como son provistos por las fuentes oficiales (NASA, ESA/Copernicus). La plataforma no emite juicios legales ni determina responsabilidades. Cualquier conclusión es responsabilidad del usuario.',
    faqQ9: '¿Por qué algunas imágenes satelitales no están disponibles o se ven con nubes?',
    faqA9: 'Las imágenes Sentinel-2 son ópticas y dependen de las condiciones atmosféricas al momento de la captura. Si había nubes sobre la zona en la fecha seleccionada, la imagen puede estar parcial o totalmente cubierta. La plataforma no puede controlar esto. Se recomienda seleccionar varias fechas para encontrar imágenes despejadas.',
    faqQ10: '¿Cómo se financia {appName}?',
    faqA10: '{appName} opera sobre infraestructura de costo cero: Oracle Cloud Free Tier para el servidor, Supabase Free Tier para la base de datos, y Google Earth Engine Free Tier para el procesamiento satelital. Es un proyecto de desarrollo individual sin financiamiento externo.',
    faqQ11: '¿Por qué las detecciones de incendios no aparecen en tiempo real?',
    faqA11: 'Los satélites VIIRS y MODIS pasan sobre Argentina varias veces al día, pero la información se procesa y publica con un retraso de 3 a 12 horas. {appName} ingiere estos datos cada 12 horas. Esto significa que las detecciones que se muestran son de horas atrás, no del momento exacto.',
    faqCtaPrompt: '¿No encontraste lo que buscabas?',
    faqCtaAction: 'Contáctanos directamente',

    // Glossary
    glossaryTitle: 'Glosario',
    glossarySubtitle: 'Términos técnicos utilizados en el monitoreo de incendios forestales',
    glossaryCategorySatellite: 'Satelital',
    glossaryCategoryEnvironmental: 'Ambiental',
    glossaryCategoryLegal: 'Legal',
    glossaryTermFrp: 'FRP (Fire Radiative Power)',
    glossaryDefFrp: 'Potencia Radiativa del Fuego. Medida de la intensidad de un incendio expresada en megawatts (MW). Indica la cantidad de energía radiante liberada por el fuego por unidad de tiempo. Se utiliza para clasificar la severidad de los incendios: Baja (<100 MW), Media (100-500 MW), Alta (>500 MW), Crítica (>1000 MW).',
    glossaryTermNdvi: 'NDVI (Normalized Difference Vegetation Index)',
    glossaryDefNdvi: 'Índice de Vegetación de Diferencia Normalizada. Indicador derivado de imágenes satelitales que mide la salud y densidad de la vegetación. Sus valores van de -1 a 1, donde valores cercanos a 1 indican vegetación densa y saludable, mientras que valores negativos indican agua, nieve o superficies sin vegetación.',
    glossaryTermLaw: 'Ley 26.815',
    glossaryDefLaw: 'Ley de Manejo del Fuego de Argentina. Establece presupuestos mínimos de protección ambiental en materia de incendios forestales, rurales y de interfase. Incluye disposiciones que prohíben el cambio de uso del suelo en zonas afectadas por incendios por períodos de hasta 60 años, para prevenir incendios intencionales con fines especulativos.',
    glossaryTermModis: 'MODIS',
    glossaryDefModis: 'Moderate Resolution Imaging Spectroradiometer. Instrumento científico a bordo de los satélites Terra y Aqua de la NASA. Captura datos en 36 bandas espectrales y es fundamental para la detección de incendios activos y el monitoreo de cambios en la vegetación a escala global.',
    glossaryTermViirs: 'VIIRS',
    glossaryDefViirs: 'Visible Infrared Imaging Radiometer Suite. Sensor a bordo de los satélites Suomi NPP y NOAA-20. Proporciona datos de mayor resolución que MODIS y es capaz de detectar incendios más pequeños y con mayor precisión geográfica.',
    glossaryTermHotspot: 'Punto de Calor',
    glossaryDefHotspot: 'Anomalía térmica detectada por satélite que indica una posible actividad de fuego. No todos los puntos de calor corresponden a incendios forestales; pueden incluir quemas agrícolas controladas, actividad industrial o volcánica.',
    glossaryTermBurnedArea: 'Área Quemada',
    glossaryDefBurnedArea: 'Superficie total afectada por un incendio, medida en hectáreas. Se calcula mediante análisis de imágenes satelitales comparando el estado pre y post incendio utilizando índices como NBR (Normalized Burn Ratio).',
    glossaryTermLandAudit: 'Verificación de Uso del Suelo',
    glossaryDefLandAudit: 'Proceso de consulta que cruza la ubicación de un terreno con datos históricos de incendios y restricciones de la Ley 26.815, mostrando el estado del suelo y la evolución de la vegetación en la zona.',

    // Contact page and form
    contactPageTitle: 'Contacto',
    contactPageSubtitle: '¿Tienes preguntas o comentarios? Estamos aquí para ayudarte.',
    contactPageUrgentMessage: 'Para consultas urgentes relacionadas con incendios activos, por favor contacte directamente al Sistema Nacional de Manejo del Fuego al teléfono 0800-222-4825.',
    contactFormTitle: 'Envíanos un mensaje',
    contactFormDescription: 'Complete el formulario y nos pondremos en contacto lo antes posible.',
    contactName: 'Nombre',
    contactSurname: 'Apellido',
    contactEmail: 'Correo Electrónico',
    contactSubject: 'Asunto',
    contactMessage: 'Descripción',
    contactAttachment: 'Adjunto (Opcional)',
    contactNamePlaceholder: 'Tu nombre',
    contactSurnamePlaceholder: 'Tu apellido',
    contactEmailPlaceholder: 'tu@email.com',
    contactSubjectPlaceholder: 'Selecciona un asunto',
    contactDescriptionPlaceholder: 'Describe tu consulta con el mayor detalle posible...',
    contactSelectFile: 'Seleccionar archivo',
    contactAttachmentAlt: 'Vista previa del adjunto',
    contactAllowedFormats: 'Formatos permitidos: PDF, JPG, PNG (máx. 5MB)',
    contactSending: 'Enviando...',
    contactSend: 'Enviar Mensaje',
    contactSubjectSupport: 'Soporte Técnico',
    contactSubjectSales: 'Ventas / Consultas Comerciales',
    contactSubjectOther: 'Otro',
    contactValidationNameRequired: 'Nombre requerido',
    contactValidationNameTooLong: 'Nombre demasiado largo',
    contactValidationSurnameTooLong: 'Apellido demasiado largo',
    contactValidationEmailInvalid: 'Correo inválido',
    contactValidationSubjectRequired: 'Asunto requerido',
    contactValidationSubjectTooLong: 'Asunto demasiado largo',
    contactValidationDescriptionShort: 'Mensaje demasiado corto',
    contactValidationDescriptionTooLong: 'Mensaje demasiado largo',
    contactValidationAttachmentTooLarge: 'El adjunto supera 5MB',
    contactValidationAttachmentType: 'Tipo de archivo no permitido',
    contactToastSuccessTitle: 'Consulta enviada con éxito',
    contactToastSuccessDescription: 'Nos pondremos en contacto contigo pronto.',
    contactToastErrorTitle: 'Error al enviar consulta',
    contactToastErrorDescription: 'Por favor intente nuevamente más tarde.',

    // Footer
    footerBrandLine1: 'Plataforma de monitoreo y recuperación de incendios forestales de Argentina.',
    footerBrandLine2: 'Protegemos nuestros bosques entre todos.',
    footerProduct: 'Producto',
    footerSupport: 'Soporte',
    footerInformative: 'Informativos',
    footerPublicSources: 'Fuentes públicas',
    footerLinkHistory: 'Históricos',
    footerLinkMap: 'Mapa de Incendios',
    footerLinkAudit: 'Verificar terreno',
    footerLinkExploration: 'Exploración satelital',
    footerLinkFaq: 'Preguntas Frecuentes',
    footerLinkManual: 'Manual de Usuario',
    footerLinkGlossary: 'Glosario',
    footerLinkContact: 'Contacto',
    footerLinkApiDocs: 'API Docs',
    footerExternalProtectedAreasLabel: 'Parques Nacionales',
    footerExternalDailyReportLabel: 'Reporte diario de incendios',
    footerExternalProtectedAreasTooltip: 'Información sobre áreas protegidas nacionales.',
    footerExternalDailyReportTooltip: 'Informes diarios de estado de situación de incendios.',
    footerExternalSnmfLabel: 'Servicio Nacional de Manejo del Fuego',
    footerExternalSnmfTooltip: 'Sitio oficial del SNMF con información sobre incendios en Argentina.',
    footerExternalBoletinLabel: 'Boletín Oficial',
    footerExternalBoletinTooltip: 'Normativas y publicaciones oficiales de la República Argentina.',
    footerExternalConaeLabel: 'CONAE',
    footerExternalConaeTooltip: 'Catálogo de focos de calor y áreas quemadas por satélite.',
    footerExternalSmnLabel: 'Servicio Meteorológico Nacional',
    footerExternalSmnTooltip: 'Pronósticos y alertas meteorológicas oficiales.',
    footerExternalSpmfLabel: 'SPMF Chubut',
    footerExternalSpmfTooltip: 'Servicio de Prevención y Lucha contra Incendios Forestales de Chubut.',
    footerExternalSplifLabel: 'SPLIF Río Negro',
    footerExternalSplifTooltip: 'Servicio de Prevención y Lucha contra Incendios Forestales de Río Negro.',
    footerLegalTitle: 'Términos de uso',
    footerLegalP1: 'Aviso legal sobre el uso de datos: La información, análisis y reportes generados por esta plataforma tienen un fin estrictamente informativo, educativo y de investigación. Los datos provienen del procesamiento automatizado de fuentes públicas y no constituyen evidencia legal, pericial ni oficial de ningún tipo. Los análisis satelitales pueden contener márgenes de error y no reemplazan el criterio de las autoridades competentes.',
    footerLegalP2: 'Fuentes de datos: Los focos de calor son provistos por el sistema FIRMS de la NASA. El procesamiento de imágenes satelitales se realiza a través de Google Earth Engine, utilizando datos públicos de las misiones Landsat (USGS) y Sentinel (ESA).',
    footerCopyright: 'Todos los derechos reservados.',
    footerMadeWith: 'Hecho con',
    footerProtectForests: 'para proteger nuestros bosques',
    footerLeavingTitle: 'Estás saliendo de {appName}',
    footerLeavingDescription: 'Vas a ser redirigido a un sitio externo oficial. El contenido de este sitio no depende de nosotros.',
    footerCancel: 'Cancelar',
    footerContinue: 'Continuar',
  },
  en: {
    // Navigation
    home: 'Home',
    map: 'Map',
    audit: 'Verify land',
    profile: 'Profile',
    login: 'Login',
    loginWelcome: 'Welcome to {appName}',
    loginSubtitle: 'Access satellite data and specialized reports\\nto protect our forests.',
    loginGoogle: 'Continue with Google',
    loginEmail: 'Continue with email',
    loginGuestDivider: 'or continue as guest',
    loginGuestAction: 'Continue as guest',
    logout: 'Logout',
    register: 'Register',
    loginSuccess: 'Login successful',
    registerTitle: 'Create your {appName} account',
    registerSubtitle: 'Sign up to access satellite data and specialized\\nfire reports.',
    registerAction: 'Register with email',
    registerSuccess: 'We sent you a link to finish your registration.',
    registerError: 'Registration failed',
    registerGuestDivider: 'or continue as guest',
    registerGuestAction: 'Continue as guest',
    registerHaveAccount: 'Already have an account?',
    firstName: 'First name',
    lastName: 'Last name',
    certificates: 'Certificates',
    shelters: 'Shelters',
    report: 'Report',
    reports: 'Explore',
    seeDetail: 'See detail',
    creditsTitle: 'Credits',
    creditsDescription: 'Buy credits for judicial or historical reports.',
    creditsBalance: 'Credits balance',
    creditsBalanceHint: 'Credits are applied automatically after payment.',
    creditsPackages: 'Available packages',
    creditsPackagesHint: 'Select a package to continue with payment.',
    creditsPackageLabel: 'Credits',
    creditsBuy: 'Buy',
    creditsPurchaseTitle: 'Buy credits',
    creditsPurchaseDescription: 'Enter the credit amount and continue to MercadoPago.',
    creditsAmountLabel: 'Credits amount',
    creditsAmountPlaceholder: 'e.g. 10',
    creditsAmountHint: 'Min 1, max 100',
    creditsAmountError: 'Enter a value between 1 and 100.',
    creditsProceed: 'Go to MercadoPago',
    editProfile: 'Edit profile',
    profileTitle: 'User profile',
    profileDescription: 'Update your details and manage credits.',
    profileEditTitle: 'Profile details',
    profileEditDescription: 'Update your basic account information.',
    profileNameLabel: 'Full name',
    profileNamePlaceholder: 'Your name',
    profileEmailLabel: 'Email',
    profileSave: 'Save changes',
    profileSaveSuccess: 'Profile updated',
    profileSaveError: 'Unable to update profile',
    profileCreditsTitle: 'Add credits',
    profileCreditsDescription: 'Buy credits to access premium reports.',
    navExplore: 'Explore',
    navTools: 'Tools',
    navAccount: 'Account',
    navHelp: 'Help',
    navMoreInformation: 'More information',
    navMenu: 'Menu',
    navOpenMenu: 'Open navigation menu',
    navPreferences: 'Preferences',

    // Common
    viewDetails: 'View Details',
    goBack: 'Go back',
    download: 'Download',
    submit: 'Submit',
    cancel: 'Cancel',
    next: 'Next',
    previous: 'Previous',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    active: 'Active',
    monitoring: 'Monitoring',
    extinguished: 'Extinguished',
    loading: 'Loading...',
    authRequired: 'Log in to continue.',
    protectedPageTitle: 'Restricted access',
    protectedPageMessage: 'This page is exclusive for registered users. Please log in to continue.',

    // Fire Feed
    fireFeed: 'Wildfire Feed',
    activeFiresArgentina: 'Active fires in Argentina',
    fireHistory: 'Historical data',
    highSeverity: 'High Severity',
    mediumSeverity: 'Medium Severity',
    lowSeverity: 'Low Severity',
    hectares: 'hectares',
    province: 'Province',
    status: 'Status',
    severity: 'Severity',
    date: 'Date',
    recentFiresToggle: 'Show recent',
    recentFiresEmpty: 'No active or recent fires in the last 60 days.',
    fireLoadError: 'Error loading fires',
    fireLoadErrorDetail: 'Could not fetch data. Check your connection and try again.',
    sortByDate: 'Sort by date',
    sortNewestFirst: 'Newest first',
    sortOldestFirst: 'Oldest first',

    // Fire Detail
    reliabilityScore: 'Reliability Score',
    landUseStatus: 'Land Use Status',
    vegetationRecovery: 'Vegetation Recovery (NDVI)',
    downloadReport: 'Download Technical Report',
    reportSuspicious: 'Report Suspicious Activity',
    prohibitedLandUse: 'Prohibited Land Use',
    protectedArea: 'Protected Area',
    underReview: 'Under Review',
    noRestrictions: 'No Restrictions',
    qualityIndicator: 'Data quality',
    qualityClassification: 'Classification',
    qualityHigh: 'High',
    qualityMedium: 'Medium',
    qualityLow: 'Low',
    avgConfidence: 'Average confidence',
    detections: 'Detections',
    independentSources: 'Independent sources',
    imagery: 'Imagery',
    imageryUnavailable: 'No satellite imagery available',
    climate: 'Climate',
    ndvi: 'NDVI',
    qualityUnavailable: 'Data quality unavailable',
    qualityWarnings: 'Warnings',
    qualityNoWarnings: 'No relevant warnings',
    qualityUpdatedAt: 'Updated',

    // Map
    interactiveMap: 'Active fires',
    clickForDetails: 'Click for details',
    area: 'Area',
    firePopupTitleActive: 'Active fire',
    firePopupTitleMonitoring: 'Fire under monitoring',
    firePopupTitleControlled: 'Controlled fire',
    firePopupTitleExtinguished: 'Extinguished fire',
    severityHigh: 'High severity',
    severityMedium: 'Medium severity',
    severityLow: 'Low severity',
    protectedAreaLabel: 'Protected area',
    popupHectaresAmount: 'Hectares',
    popupProtectedAreaPercentage: 'Protected area affected',
    popupProtectedAreas: 'Protected areas',
    mapLegendActive: 'Active',
    mapLegendRecent: 'Recent (60 days)',

    // Audit / Verify land
    landUseAudit: 'Verify land',
    auditDescription: 'Investigate if an area burned, how vegetation changed, and what traces remain.',
    auditLocationInput: 'Search place',
    auditLocationHint: 'Search by address or pick a point on the map.',
    auditMapHint: 'Mark a point on the map to continue.',
    latitude: 'Latitude',
    longitude: 'Longitude',
    radiusMeters: 'Radius (meters)',
    pickOnMap: 'Pick on Map',
    runAudit: 'Verify',
    auditResult: 'Verification Result',
    explorationInstruction:
      'Choose an area that has suffered a fire. Get a satellite image from before as a starting point. Then, look for up to 12 HD satellite images, with monthly or annual periodicity, to see how the affected terrain evolved. Analyze if the vegetation recovered or if there were other important changes in the zone.',
    constructionProhibited: 'Construction Prohibited',
    prohibitedUntil: 'Prohibited until',
    noRestrictionsFound: 'No restrictions found',
    reportsTitle: 'Explore land evolution',
    reportsDescription:
      'Choose a fire and compare before/after in HD imagery. Investigate what changed and when.',
    explorationDisclaimer:
      'This is not an accusation: it is a tool to observe changes with satellite evidence.',
    explorationHowTitle: 'How it works',
    explorationHowStep1: 'Pick a fire (province, date, or map).',
    explorationHowStep2: 'Select up to 12 dates to generate imagery.',
    explorationHowStep3: 'Generate HD images and compare them.',
    explorationDemoTitle: 'Before and after (example)',
    explorationDemoHint: 'Illustrative only, no imagery generated.',
    explorationDemoExample: 'Illustrative example.',
    explorationStep1Title: 'Choose a fire',
    explorationStep1Subtitle: 'Search by province, date, or free text.',
    explorationStep2Title: 'Pick period and quantity',
    explorationStep2Subtitle: 'Define before and after. Up to 12 images.',
    explorationStep3Title: 'Your investigation',
    explorationStep3Subtitle: 'Review dates, total cost, and save the draft.',
    explorationAdvancedIdLabel: 'I have the event ID',
    explorationAdvancedIdPlaceholder: 'Fire UUID',
    explorationAdvancedIdAction: 'Load event',
    explorationCoordsTitle: 'Search by coordinates',
    explorationCoordsHint: 'Enter latitude, longitude, and radius to search nearby fires.',
    explorationCoordsError: 'Provide valid latitude, longitude, and radius.',
    explorationMapSelect: 'Pick on map',
    explorationSearchPlaceholder: 'e.g. Corrientes 2022, El Bolsón 2021',
    explorationResults: 'Results',
    explorationSelect: 'Select',
    explorationSelected: 'Selected',
    explorationBeforeLabel: 'Before the fire',
    explorationAfterLabel: 'After the fire',
    explorationTotalLabel: 'Total count',
    explorationPresetsLabel: 'Quick presets',
    explorationMoreDetail: 'More images = more temporal detail.',
    explorationTimelineTitle: 'Suggested timeline',
    explorationTitleLabel: 'Investigation title (optional)',
    explorationTitlePlaceholder: 'What happened here?',
    explorationAddItemLabel: 'Add date',
    explorationAddItemAction: 'Add',
    explorationCostLabel: 'Cost summary',
    explorationConfirmTitle: 'Confirm generation',
    explorationConfirmDescription: 'We will charge your account',
    explorationConfirmAction: 'Confirm and generate',
    explorationAuthTitle: 'Account required to generate the report',
    explorationAuthMessageLine1: 'To generate this personalized report you need an account.',
    explorationAuthMessageLine2:
      'Registration is free and lets you access your reports, history, and downloads.',
    explorationAuthBack: 'Go back',
    explorationAuthLogin: 'Sign up / Log in',
    explorationGenerationStarted: 'Generation started. ID:',
    explorationTrackingTitle: 'Generation in progress',
    explorationTrackingIdLabel: 'Tracking ID:',
    explorationInsufficientCredits: 'Insufficient credits',
    explorationSave: 'Save findings',
    explorationGenerate: 'Generate HD images',
    explorationDownloadTitle: 'Choose how to download your exports',
    explorationCostNote:
      'Each HD image is generated on demand and has a satellite query cost. You only pay for what you generate.',
    explorationNoResultsTitle: 'No fires found with those filters.',
    explorationNoResultsHint: 'Try: Corrientes 2022 · El Bolsón 2021.',
    explorationAddressNotInProvince: 'The address does not exist in the selected province.',
    explorationDatesRequired: 'Please set the date range (from and to) to search.',
    explorationEventSummary: 'Event summary',
    explorationMapPreview: 'Fire map',
    explorationDetectTitle: 'What you could detect',
    explorationDetectOption1: 'New constructions',
    explorationDetectOption2: 'Road openings',
    explorationDetectOption3: 'Soil movement',
    explorationDetectOption4: 'Vegetation cover changes',
    explorationDetectOption5: 'Parcel or boundary changes',
    explorationHypothesisTitle: 'Pick a hypothesis',
    explorationHypothesis1: 'Was there construction after the fire?',
    explorationHypothesis2: 'Did land use change?',
    explorationHypothesis3: 'Did vegetation recover?',
    explorationEstimateTag: 'Estimated',
    explorationUpdateCost: 'Update cost',
    explorationLoadingQuote: 'Calculating cost...',
    explorationLoadMore: 'Load more',
    explorationSaved: 'Investigation saved',
    explorationGenerateSoon: 'You will soon be able to generate HD images.',
    explorationMapLoading: 'Loading map...',
    reportType: 'Report type',
    judicialReport: 'Judicial',
    judicialReportHint: 'Legal forensic report with chain of custody.',
    historicalReport: 'Historical',
    historicalReportHint: 'Temporal evolution for protected areas.',
    reportFireEventId: 'Fire event ID',
    reportRequesterName: 'Requester name',
    reportCaseReference: 'Case reference',
    reportIncludeImagery: 'Include satellite imagery',
    reportIncludeImageryHint: 'HD imagery for legal evidence.',
    reportIncludeClimate: 'Include climate data',
    reportIncludeClimateHint: 'Meteorological context of the event.',
    reportProtectedAreaId: 'Protected area ID',
    reportProtectedAreaName: 'Protected area name',
    reportStartDate: 'Start date',
    reportEndDate: 'End date',
    reportMaxImages: 'Max images',
    reportIncludeMonthly: 'Include monthly imagery',
    reportIncludeMonthlyHint: 'Post-fire monthly series.',
    reportEstimatedCost: 'Estimated credits',
    reportSubmit: 'Request report',
    reportCreditsAvailable: 'Available credits',
    reportCreditsRequired: 'Credits required',
    reportCreditsHint: '1 credit = 1 HD image (max 12)',
    creditsFallback: 'Estimated balance (demo mode).',
    reportPendingApproval: 'Request pending approval',
    reportPendingApprovalMessage:
      'Insufficient balance. The request will wait for admin approval.',
    reportSubmitted: 'Report generated',
    reportReady: 'Report ready',
    reportReadyMessage: 'The report was generated and is ready to download.',
    reportDownload: 'Download report',
    reportOpenViewer: 'Open viewer',
    reportVerificationHash: 'Verification hash',
    reportId: 'Report ID',
    reportGeneratedAt: 'Generated at',
    reportFiresIncluded: 'Fires included',
    reportError: 'Request error',
    reportDateRangeInvalid: 'End date must be after start date',
    reportProtectedAreaRequired: 'Provide protected area ID or name',
    reportMaxImagesRange: 'Must be between 1 and 12',
    invalidValue: 'Invalid value',
    firesFound: 'Fires found',
    distanceMeters: 'Distance (m)',
    yearsRemaining: 'Years remaining',
    auditWarnings: 'Warnings',
    verifyTerrain: 'Verify land',
    verifySubtitle: 'Investigate if an area burned, how vegetation changed, and what traces remain.',
    verifyMicrocopyA: 'Some fires are accidental; others may have interests behind them. Here you can look at evidence and draw your own conclusions.',
    verifyMicrocopyB: 'This alone does not prove intent. It helps contrast stories with observable evidence.',
    searchPlace: 'Search place',
    searchPlaceholder: 'Address, town, national park or province',
    searchTypeLabel: 'Search type',
    searchTypeAddress: 'Address',
    searchTypeLocality: 'Locality',
    searchTypePark: 'Park',
    searchTypeProvince: 'Province',
    searchTypeMinLength: 'Minimum {min} characters',
    searchTypeInvalidFormat: 'Invalid format',
    analysisArea: 'Analysis area',
    advancedOptions: 'Advanced options',
    customRadius: 'Custom radius (m)',
    verifyCTA: 'Verify',
    whatYouWillSee: 'What you will see',
    seeTimeline: 'Timeline of detected fires',
    seeVegetation: 'Vegetation evolution (indicators)',
    seeGallery: 'Evidence gallery (thumbnails)',
    seeSignals: 'Signals for/against recovery',
    emptyHint: 'Mark a point on the map and press Verify.',
    loadingFires: 'Searching historical fires…',
    loadingVegetation: 'Calculating vegetation evolution…',
    loadingEvidence: 'Loading visual evidence…',
    errorTitle: 'Verification failed',
    noPointError: 'First mark a point on the map.',
    technicalError: 'There was a technical problem. Try again.',
    geocodeLoading: 'Finding location…',
    geocodeNotFound: 'We could not locate that place. Try another search or mark a point on the map.',
    auditSearchLoading: 'Searching historical episodes…',
    resolvedPlace: 'Resolved place',
    episodesFound: 'Episodes found',
    dateRange: 'Range',
    auditSearchEmpty: 'No episodes found for that place.',
    placeTypeProvince: 'Province',
    placeTypeProtectedArea: 'Protected area',
    placeTypeAddress: 'Address',
    retry: 'Retry',
    verificationChecklist: 'Verification checklist',
    checklist1: 'Were there fires in recent years in this area?',
    checklist2: 'Did vegetation recover or remain degraded?',
    checklist3: 'Do fire traces persist in the area?',
    checklist4: 'What do public sources and local records say?',
    evidenceGallery: 'Evidence gallery',
    loginToDownload: 'Log in to download',
    hideMap: 'Hide map',
    results: 'Results',
    requiredField: 'Required field',
    eventsLabel: 'Events',
    invalidNumber: 'Invalid number',
    outOfRange: 'Value out of range',

    // Certificates
    certificateCenter: 'Certificate Center',
    requestCertificate: 'Request Certificate',
    verifyCertificate: 'Verify Certificate',
    cadastralId: 'Cadastral ID',
    ownerName: 'Owner Name',
    issueCertificate: 'Issue Certificate',
    certificateId: 'Certificate ID',
    verify: 'Verify',
    valid: 'Valid',
    invalid: 'Invalid',
    certificateIssued: 'Certificate Issued',
    certificateValid: 'The certificate is valid',
    certificateInvalid: 'The certificate is invalid or does not exist',

    // Citizen Report
    citizenReport: 'Citizen Report',
    reportWizard: 'Report Wizard',
    selectLocation: 'Select Location',
    uploadPhoto: 'Upload Photo',
    description: 'Description',
    submitReport: 'Submit Report',
    reportSuccess: 'Evidence Package Generated',
    reportSuccessMessage: 'Your report has been successfully submitted and will be reviewed by authorities.',
    descriptionPlaceholder: 'Describe the suspicious activity you observed...',

    // Shelters
    visitorLog: 'Visitor Log',
    shelterName: 'Shelter Name',
    hikerName: 'Hiker Name',
    groupSize: 'Group Size',
    checkIn: 'Check-in',
    syncStatus: 'Sync Status',
    online: 'Online',
    offline: 'Offline (Saved Locally)',
    checkInSuccess: 'Check-in successful',

    // Login
    email: 'Email',
    password: 'Password',
    loginButton: 'Login',
    noAccount: "Don't have an account?",
    loginError: 'Please fill in all fields',
    loginInvalid: 'Invalid log credentials',

    // Footer
    legal: 'Legal',
    contact: 'Contact',
    apiDocs: 'API Docs',

    // Roles
    guest: 'Guest',
    user: 'User',
    admin: 'Administrator',

    // PaymentReturnPage
    paymentLoadingSession: 'Loading session...',
    paymentRestoringSession: 'We are restoring your session before verifying the payment.',
    paymentSessionRequired: 'Session required',
    paymentLoginToVerify: 'Log in to verify payment status.',
    paymentGoToLogin: 'Go to login',
    paymentNotFound: 'Payment not found',
    paymentIdentifyError: 'We could not identify the payment. Try again from Credits.',
    paymentGoToCredits: 'Go to Credits',
    paymentVerificationInProgress: 'Verification in progress',
    paymentProcessingMessage: 'Your payment is being processed. You will receive a confirmation email when it is credited.',
    paymentGoToHome: 'Back to home',
    paymentVerifying: 'Verifying payment...',
    paymentPleaseWait: 'Please wait while we confirm your payment.',
    paymentSuccessful: 'Payment successful!',
    paymentCreditedMessage: 'Your credits have been credited to your account.',
    paymentContinue: 'Continue',
    paymentRejected: 'Payment rejected',
    paymentRejectedMessage: 'We could not process your payment. Please try again.',
    paymentTryAgain: 'Try again',

    // Register Validation
    validationRequired: 'Field required',
    validationMax50: 'Max 50 characters',
    validationInvalidEmail: 'Invalid email',

    // Login Hero
    loginHeroTitle: 'The footprint of fire, seen from space.',
    loginHeroSubtitle: 'Generate satellite timelines of fires in Argentina.',
    loginHeroDescription: 'Compare before and after: detect natural revegetation or unauthorized constructions in affected areas.',
    loginIdleSession: 'Session closed due to inactivity',

    // NotFound
    notFoundTitle: 'Page not found',
    notFoundMessage: 'The page you are looking for does not exist or was moved.',
    notFoundBackHome: 'Back to home',

    // FireCard
    statusActive: 'Active',
    statusMonitoring: 'Monitoring',
    statusExtinct: 'Extinct',
    statusClosed: 'Closed',
    noProvince: 'No province',
    goToSlide: 'Go to slide {index}',
    imagePending: 'Image pending',
    recentLabel: 'Recent',

    // Language Selector
    languageSpanish: 'Spanish',
    languageEnglish: 'English',
    toggleLanguage: 'Toggle language',

    // Manual
    manualTitle: 'User Manual',
    manualSubtitle: 'Complete guide to using {appName}',
    manualContent: 'Contents',
    manualNavigation: 'Navigation',
    manualPrevious: 'Previous',
    manualNext: 'Next',
    manualSectionCounter: 'Section {current} of {total}',
    manualSectionGettingStarted: 'Getting Started',
    manualSectionFireMap: 'Fire Map',
    manualSectionLegalAudit: 'Land Verification',
    manualSectionReports: 'Citizen Reports',
    manualSectionCertificates: 'Certificates',
    manualGettingStartedP1: 'Welcome to {appName}, the wildfire monitoring and recovery platform for Argentina.',
    manualGettingStartedP2: 'This guide will help you make the most of all available features.',
    manualRegisterAccessTitle: 'Registration and Access',
    manualRegisterAccess1: 'Go to the {appName} home page',
    manualRegisterAccess2: 'Click "Login" in the navigation bar',
    manualRegisterAccess3: 'Enter your email and password',
    manualRegisterAccess4: 'For administrator accounts, use an email with @{appSlug}.ar domain',
    manualMainNavTitle: 'Main Navigation',
    manualMainNav1: 'Home: Active fire feed with filters',
    manualMainNav2: 'Map: Interactive geographic visualization',
    manualMainNav3: 'Verify land: Explore fire history and land evolution',
    manualMainNav4: 'Certificates: Document issuance and verification',
    manualMapP1: 'The interactive map shows all fires detected in Argentina in near real time.',
    manualColorsTitle: 'Color Interpretation',
    manualColorLow: 'Green: Low severity (FRP below 100 MW)',
    manualColorMedium: 'Yellow: Medium severity (FRP 100-500 MW)',
    manualColorHigh: 'Orange: High severity (FRP 500-1000 MW)',
    manualColorCritical: 'Red: Critical (FRP above 1000 MW)',
    manualFeaturesTitle: 'Features',
    manualFeatures1: 'Click a marker to view fire details',
    manualFeatures2: 'Use side filters to filter by province or severity',
    manualFeatures3: 'Zoom allows you to explore specific areas',
    manualAuditP1: 'The land verification tool lets you explore whether an area was affected by fires, how vegetation changed, and what traces remain. It cross-references Law 26.815 data with satellite information to provide context.',
    manualAuditHowToTitle: 'How to verify land',
    manualAuditHowTo1: 'Enter parcel coordinates (latitude and longitude)',
    manualAuditHowTo2: 'Alternatively, use the "Select on Map" button',
    manualAuditHowTo3: 'Click "Verify"',
    manualAuditHowTo4: 'The system will search for historical fires, show vegetation evolution, and present visual evidence',
    manualAuditResultsTitle: 'Possible results',
    manualAuditResults1: 'No restrictions: No recent fires affect the parcel',
    manualAuditResults2: 'Construction prohibited: The parcel is inside an affected zone and has temporary restrictions',
    manualReportsP1: 'The reporting system allows any citizen to report suspicious activity related to wildfires.',
    manualReportsStepsTitle: 'Steps to create a report',
    manualReportsSteps1: 'Location: Select the exact point on the map where you observed the activity',
    manualReportsSteps2: 'Photo: Upload an image as evidence (optional but recommended)',
    manualReportsSteps3: 'Description: Describe what you observed in as much detail as possible',
    manualReportsSteps4: 'Submit: Confirm and send the report for review',
    manualReportsTipsTitle: 'Recommendations',
    manualReportsTips1: 'Include approximate date and time of observation',
    manualReportsTips2: 'Describe any vehicle or person involved',
    manualReportsTips3: 'Do not put yourself at risk to collect evidence',
    manualCertP1: 'The Certificate Center allows you to request and verify official documents about land-use status for a parcel.',
    manualCertRequestTitle: 'Request a Certificate',
    manualCertRequest1: 'Go to the Certificate Center (authentication required)',
    manualCertRequest2: 'Enter the parcel Cadastral ID',
    manualCertRequest3: 'Fill in the owner name',
    manualCertRequest4: 'The system will generate a certificate with a unique code',
    manualCertVerifyTitle: 'Verify a Certificate',
    manualCertVerify1: 'Enter the certificate code in the "Verify" tab',
    manualCertVerify2: 'The system will confirm whether it is valid and show details',

    // Manual - Episodes
    manualSectionEpisodes: 'Episodes',
    manualEpisodesP1: 'An episode groups multiple satellite detections that correspond to the same fire. When a satellite passes over the same burning area several times, each pass generates an independent detection. {appName} groups them automatically into a single episode for easier tracking.',
    manualEpisodesP2: 'Episodes let you see the full evolution of a fire: when it started, how long it lasted, what area it covered, and how vegetation evolved afterwards.',
    manualEpisodesHowTitle: 'How episodes are created',
    manualEpisodesHow1: 'Nearby detections in space and time are grouped automatically using a clustering algorithm',
    manualEpisodesHow2: 'An estimated area, duration, and intensity statistics (max FRP, total detections) are calculated',
    manualEpisodesHow3: 'Satellite imagery is assigned when available for the area and dates of the episode',

    // FAQ
    faqTitle: 'Frequently Asked Questions',
    faqSubtitle: 'Answers to common questions about wildfires and our platform',
    faqHint: 'Click each question to view the answer',
    faqQ1: 'How does {appName} detect wildfires?',
    faqA1: '{appName} uses satellite data from multiple sources, including MODIS (NASA) and VIIRS, which detect hotspots in near real time. These satellites orbit Earth several times a day, capturing thermal imagery that helps identify active fire points. Information is processed automatically and displayed on our platform with updates every 6-12 hours.',
    faqQ2: 'What does FRP (Fire Radiative Power) mean?',
    faqA2: 'FRP is a measure of fire intensity, expressed in megawatts (MW). It indicates the amount of energy released by fire per unit of time. A higher FRP means a more intense fire. In {appName}, we classify fires as low (<100 MW), medium (100-500 MW), high (>500 MW), and critical (>1000 MW).',
    faqQ3: 'What is NDVI and why is it important for recovery?',
    faqA3: 'NDVI (Normalized Difference Vegetation Index) measures vegetation health and density using satellite imagery. Values range from -1 to 1, where values near 1 indicate dense, healthy vegetation. After a fire, we monitor NDVI to evaluate ecosystem recovery. A gradual NDVI increase indicates vegetation regeneration.',
    faqQ4: 'How does Law 26.815 (Fire Management Law) work?',
    faqA4: 'Law 26.815 sets minimum environmental protection standards for wildfires. A key aspect is that it prohibits land-use change in fire-affected areas for a defined period (generally 60 years), preventing fires from being used to enable agriculture or construction. The land verification tool lets you check if an area is affected by these restrictions.',
    faqQ5: 'Can I report a fire I detected personally?',
    faqA5: 'Yes. {appName} includes a Citizen Report system that lets anyone report suspicious activity or visually detected fires. The workflow includes geolocation, photo upload, and event description. Reports are reviewed by competent authorities and may support investigations of intentional fires.',
    faqQ6: 'Where does {appName}\'s data come from?',
    faqA6: '{appName} centralizes public data from multiple sources: hotspot detections from NASA FIRMS (VIIRS and MODIS satellites), multispectral Sentinel-2 imagery processed via Google Earth Engine, climate data from Open-Meteo (ERA5-Land), and protected area geometries from IGN and APN. All information comes from public and open sources.',
    faqQ7: 'How are satellite images generated?',
    faqA7: 'Images are generated on demand through Google Earth Engine. {appName} sends a request with the selected coordinates and dates, GEE processes the corresponding Sentinel-2 image and delivers it in optimized format. The process can take between 30 seconds and several minutes depending on service load.',
    faqQ8: 'Does {appName} prove legal responsibility for fires?',
    faqA8: 'No. {appName} is a public data exploration tool. Data is presented as provided by official sources (NASA, ESA/Copernicus). The platform does not issue legal judgments or determine responsibility. Any conclusions drawn are the user\'s responsibility.',
    faqQ9: 'Why are some satellite images unavailable or cloudy?',
    faqA9: 'Sentinel-2 images are optical and depend on atmospheric conditions at the time of capture. If there were clouds over the area on the selected date, the image may be partially or fully covered. The platform cannot control this. It is recommended to select multiple dates to find clear images.',
    faqQ10: 'How is {appName} funded?',
    faqA10: '{appName} runs on zero-cost infrastructure: Oracle Cloud Free Tier for the server, Supabase Free Tier for the database, and Google Earth Engine Free Tier for satellite processing. It is an individual development project with no external funding.',
    faqQ11: 'Why don\'t fire detections appear in real time?',
    faqA11: 'VIIRS and MODIS satellites pass over Argentina several times a day, but information is processed and published with a 3 to 12 hour delay. {appName} ingests this data every 12 hours. This means detections shown are from hours ago, not from the exact moment.',
    faqCtaPrompt: 'Didn\'t find what you were looking for?',
    faqCtaAction: 'Contact us directly',

    // Glossary
    glossaryTitle: 'Glossary',
    glossarySubtitle: 'Technical terms used in wildfire monitoring',
    glossaryCategorySatellite: 'Satellite',
    glossaryCategoryEnvironmental: 'Environmental',
    glossaryCategoryLegal: 'Legal',
    glossaryTermFrp: 'FRP (Fire Radiative Power)',
    glossaryDefFrp: 'Fire Radiative Power. A measure of fire intensity expressed in megawatts (MW). It indicates the amount of radiant energy released by fire per unit of time. It is used to classify fire severity: Low (<100 MW), Medium (100-500 MW), High (>500 MW), Critical (>1000 MW).',
    glossaryTermNdvi: 'NDVI (Normalized Difference Vegetation Index)',
    glossaryDefNdvi: 'A satellite-derived indicator that measures vegetation health and density. Values range from -1 to 1, where values near 1 indicate dense and healthy vegetation, while negative values indicate water, snow, or non-vegetated surfaces.',
    glossaryTermLaw: 'Law 26.815',
    glossaryDefLaw: 'Argentina Fire Management Law. It establishes minimum environmental protection standards for wildfires, rural and interface fires. It includes provisions that prohibit land-use change in fire-affected zones for periods up to 60 years, to prevent intentional fires for speculative purposes.',
    glossaryTermModis: 'MODIS',
    glossaryDefModis: 'Moderate Resolution Imaging Spectroradiometer. Scientific instrument onboard NASA\'s Terra and Aqua satellites. It captures data in 36 spectral bands and is essential for active fire detection and vegetation change monitoring at global scale.',
    glossaryTermViirs: 'VIIRS',
    glossaryDefViirs: 'Visible Infrared Imaging Radiometer Suite. Sensor onboard Suomi NPP and NOAA-20 satellites. It provides higher-resolution data than MODIS and can detect smaller fires with higher geospatial precision.',
    glossaryTermHotspot: 'Hotspot',
    glossaryDefHotspot: 'A satellite-detected thermal anomaly indicating possible fire activity. Not all hotspots correspond to wildfires; they may include controlled agricultural burns, industrial or volcanic activity.',
    glossaryTermBurnedArea: 'Burned Area',
    glossaryDefBurnedArea: 'Total surface affected by a fire, measured in hectares. It is calculated through satellite image analysis comparing pre- and post-fire conditions using indices such as NBR (Normalized Burn Ratio).',
    glossaryTermLandAudit: 'Land-Use Verification',
    glossaryDefLandAudit: 'Query process that cross-references a land location with historical fire data and Law 26.815 restrictions, displaying land status and vegetation evolution in the area.',

    // Contact page and form
    contactPageTitle: 'Contact',
    contactPageSubtitle: 'Have questions or comments? We are here to help you.',
    contactPageUrgentMessage: 'For urgent inquiries related to active fires, please contact the National Fire Management System directly at 0800-222-4825.',
    contactFormTitle: 'Send us a message',
    contactFormDescription: 'Complete the form and we will contact you as soon as possible.',
    contactName: 'First name',
    contactSurname: 'Last name',
    contactEmail: 'Email',
    contactSubject: 'Subject',
    contactMessage: 'Description',
    contactAttachment: 'Attachment (Optional)',
    contactNamePlaceholder: 'Your first name',
    contactSurnamePlaceholder: 'Your last name',
    contactEmailPlaceholder: 'your@email.com',
    contactSubjectPlaceholder: 'Select a subject',
    contactDescriptionPlaceholder: 'Describe your request with as much detail as possible...',
    contactSelectFile: 'Select file',
    contactAttachmentAlt: 'Attachment preview',
    contactAllowedFormats: 'Allowed formats: PDF, JPG, PNG (max 5MB)',
    contactSending: 'Sending...',
    contactSend: 'Send Message',
    contactSubjectSupport: 'Technical Support',
    contactSubjectSales: 'Sales / Business Inquiries',
    contactSubjectOther: 'Other',
    contactValidationNameRequired: 'Name is required',
    contactValidationNameTooLong: 'Name is too long',
    contactValidationSurnameTooLong: 'Surname is too long',
    contactValidationEmailInvalid: 'Invalid email',
    contactValidationSubjectRequired: 'Subject is required',
    contactValidationSubjectTooLong: 'Subject is too long',
    contactValidationDescriptionShort: 'Message is too short',
    contactValidationDescriptionTooLong: 'Message is too long',
    contactValidationAttachmentTooLarge: 'Attachment exceeds 5MB',
    contactValidationAttachmentType: 'File type not allowed',
    contactToastSuccessTitle: 'Message sent successfully',
    contactToastSuccessDescription: 'We will contact you soon.',
    contactToastErrorTitle: 'Error sending message',
    contactToastErrorDescription: 'Please try again later.',

    // Footer
    footerBrandLine1: 'Monitoring and recovery platform for wildfires in Argentina.',
    footerBrandLine2: 'We protect our forests together.',
    footerProduct: 'Product',
    footerSupport: 'Support',
    footerInformative: 'Information',
    footerPublicSources: 'Public sources',
    footerLinkHistory: 'Historical',
    footerLinkMap: 'Fire Map',
    footerLinkAudit: 'Verify land',
    footerLinkExploration: 'Satellite exploration',
    footerLinkFaq: 'FAQ',
    footerLinkManual: 'User Manual',
    footerLinkGlossary: 'Glossary',
    footerLinkContact: 'Contact',
    footerLinkApiDocs: 'API Docs',
    footerExternalProtectedAreasLabel: 'National Parks',
    footerExternalDailyReportLabel: 'Daily wildfire report',
    footerExternalProtectedAreasTooltip: 'Information about national protected areas.',
    footerExternalDailyReportTooltip: 'Daily wildfire status reports.',
    footerExternalSnmfLabel: 'National Fire Management Service',
    footerExternalSnmfTooltip: 'Official SNMF site with wildfire information in Argentina.',
    footerExternalBoletinLabel: 'Official Gazette',
    footerExternalBoletinTooltip: 'Official regulations and publications of Argentina.',
    footerExternalConaeLabel: 'CONAE',
    footerExternalConaeTooltip: 'Satellite catalog of hotspots and burned areas.',
    footerExternalSmnLabel: 'National Weather Service',
    footerExternalSmnTooltip: 'Official forecasts and weather alerts.',
    footerExternalSpmfLabel: 'SPMF Chubut',
    footerExternalSpmfTooltip: 'Chubut Forest Fire Prevention and Suppression Service.',
    footerExternalSplifLabel: 'SPLIF Río Negro',
    footerExternalSplifTooltip: 'Río Negro Forest Fire Prevention and Suppression Service.',
    footerLegalTitle: 'Terms of use',
    footerLegalP1: 'Legal notice on data use: The information, analysis and reports generated by this platform are strictly for informational, educational and research purposes. The data comes from automated processing of public sources and does not constitute legal, expert or official evidence of any kind. Satellite analyses may contain margins of error and do not replace the judgment of competent authorities.',
    footerLegalP2: 'Data sources: Hotspots are provided by NASA\'s FIRMS system. Satellite image processing is performed through Google Earth Engine, using public data from the Landsat (USGS) and Sentinel (ESA) missions.',
    footerCopyright: 'All rights reserved.',
    footerMadeWith: 'Made with',
    footerProtectForests: 'to protect our forests',
    footerLeavingTitle: 'You are leaving {appName}',
    footerLeavingDescription: 'You will be redirected to an official external site. The content of that site does not depend on us.',
    footerCancel: 'Cancel',
    footerContinue: 'Continue',
  },
} as const

export type Language = keyof typeof translations
